import { AxiosResponse } from 'axios'
import { createApiClient } from '@/utils/httpClient'

const api = createApiClient({
    baseURL:
        process.env.NEXT_PUBLIC_API_URL ||
        'https://assine3-be.estadao.com.br/',
    headers: {
        Authorization: process.env.API_TOKEN || '',
    },
})

export const validateRecaptcha = async (
    token: string,
    action: string,
    options?: {
        accountId?: string | number
        responsavel?: {
            email?: string
            celular?: string
            nome?: string
        }
    },
): Promise<boolean> => {
    const payload: any = {
        recaptcha: {
            token,
            action,
        },
    }

    if (options?.accountId) {
        payload.accountId = String(options.accountId)
    }

    if (options?.responsavel) {
        payload.responsavel = options.responsavel
    }

    try {
        const response: AxiosResponse<string> = await api.post(
            'v1/recaptcha-validate',
            payload,
        )

        return response.data === 'true'
    } catch (err: any) {
        throw err
    }
}